require('/ui/components/modal/modal.module.scss.module.css');

export const modal = "_modal_1gnsd_1";
export const modalSmall = "_modal-small_1gnsd_1";
export const modalLarge = "_modal-large_1gnsd_1";
export const modalFullwidth = "_modal-fullwidth_1gnsd_1";
export const modalFullpage = "_modal-fullpage_1gnsd_1";
export const header = "_header_1gnsd_1";
export const content = "_content_1gnsd_1";
export const headerSmall = "_header-small_1gnsd_1";
export const headerLarge = "_header-large_1gnsd_1";
export const headerIsComplex = "_header-is-complex_1gnsd_1";
export const headerFullwidth = "_header-fullwidth_1gnsd_1";
export const headerFullpage = "_header-fullpage_1gnsd_1";
export const headerContainer = "_header-container_1gnsd_1";
export const headerContent = "_header-content_1gnsd_1";
export const headerIcon = "_header-icon_1gnsd_1";
export const headerDescription = "_header-description_1gnsd_1";
export const headerLink = "_header-link_1gnsd_1";
export const closeButton = "_close-button_1gnsd_1";
export const title = "_title_1gnsd_1";
export const titleSmall = "_title-small_1gnsd_1";
export const titleLarge = "_title-large_1gnsd_1";
export const titleFullwidth = "_title-fullwidth_1gnsd_1";
export const titleFullpage = "_title-fullpage_1gnsd_1";
export const contentOverflow = "_content-overflow_1gnsd_1";
export const footer = "_footer_1gnsd_1";
export const dialogPadding = "_dialog-padding_1gnsd_1";
